import React from "react";
import ProductInfo from "./ProductInfo";
import { MdOutlineFileDownload } from "react-icons/md";
import { useTranslation } from 'react-i18next';

/* ---------------------------------------------------------------------------- */

import {
  DownloadButton,
  DownloadList,
  ProductDescription,
  ProductDocument,
  ProductImage,
  ProductSection,
} from "./StyledComponents";

/* ----------------------------------------------------------------------------
 *          IMAGES
 * --------------------------------------------------------------------------- */

import TryggVardagBild from "../../../../data/images/products/Trygg Vardag/Tryggvardag_huvudbild.png";

/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES 
 * --------------------------------------------------------------------------- */

//import TryggVardagManual2 from "../../../../data/downloads/Manual-trygg-vardag.pdf";  // med videosamtal
import TryggVardagManual from "../../../../data/downloads/Manual_trygg-vardag_1.0.38_utan_videosamtal.pdf"; // utan videosamtal
import TryggVardagStartaUpp from "../../../../data/downloads/Starta_upp_trygg-vardag_nya.pdf";
import TryggVardagRekond from "../../../../data/downloads/Trygg_vardag_rekonditionering_nya.pdf";
import TryggVardagMobil from "../../../../data/downloads/Manual_trygg-vardag_mobil.pdf";
import TryggVardagGo from "../../../../data/downloads/Trygg-vardag_GO.pdf";


/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES - OLD
 * --------------------------------------------------------------------------- */

import TryggVardagManual_gammal from "../../../../data/downloads/Manual-trygg-vardag.pdf";  // med videosamtal
import TryggVardagManual2_gammal from "../../../../data/downloads/Manual-trygg-vardag-2.pdf"; // utan videosamtal
import TryggVardagStartaUpp_gammal from "../../../../data/downloads/Starta_upp_trygg_vardag.pdf";
import TryggVardagManualPaket1 from "../../../../data/downloads/Manual-trygg-vardag-paket-1.pdf";

import TryggVardagManualPaket2 from "../../../../data/downloads/Manual-trygg-vardag-paket-2.pdf";


/* ============================================================================ */
/*          PORT | KOMM - function
/* ============================================================================ */


const TryggVardag = () => {
  
  const { t } = useTranslation("products/tryggvardag"); 

  return (
    <main className="product container">
      <ProductSection>
        <h1>{t('h1_tryggvardag')}</h1>
        <ProductImage src={TryggVardagBild} alt="" />

        <ProductDescription>
          <p>{t('p1_tryggvardag')}</p>
        </ProductDescription>
    
        <ProductInfo titel={t('dokument_tryggvardag')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardag')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagManual} download="Manual-trygg-vardag-utan-videosamtal.pdf">
                    <span>Användarmanual ver-B</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                                 
                <DownloadButton>
                  <a href={TryggVardagStartaUpp} download="Starta_upp_trygg_vardag.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagRekond} download="manual_trygg_rekonditionering.pdf">
                    <span>Rekonditionersingsmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagMobil} download="manual_trygg_rekonditionering.pdf">
                    <span>Användarmanual Mobil</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagGo} download="manual_trygg_rekonditionering.pdf">
                    <span>Trygg│vardag GO</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>

        <ProductInfo titel={t('dokument_tryggvardag_gammal')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardag')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagManual_gammal} download="Manual-trygg-vardag-med-videosamtal.pdf">
                    <span>Användarmanual ver-A</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagManual2_gammal} download="Manual-trygg-vardag-utan-videosamtal.pdf">
                    <span>Användarmanual ver-B</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                                 
                <DownloadButton>
                  <a href={TryggVardagStartaUpp_gammal} download="Starta_upp_trygg_vardag_äldre_version.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>
        
        <ProductInfo titel={t('dokument_tryggvardag_paket')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardag')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagManualPaket1} download="TryggVardagManualPaket1.pdf">
                    <span>Trygg Vardag Manual Paket 1</span>
                    <MdOutlineFileDownload />
                  </a>
                  </DownloadButton>
                  <DownloadButton>
                  <a href={TryggVardagManualPaket2} download="TryggVardagManualPaket2.pdf">
                    <span>Trygg Vardag Manual Paket 2</span>
                    <MdOutlineFileDownload />
                  </a>
                  </DownloadButton>
                </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>

        
      </ProductSection>
    </main>
  );
};

export default TryggVardag;
